import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  [
    "Element",
    "Density",
    { role: "style" },

    {
      sourceColumn: 0,
      role: "annotation",
      type: "string",
      calc: "stringify",
    },
  ],
  ["Unplanned", 84, "#2cb4d4", null],
  ["Planned", 10.49, "#1787b8", null],
  ["Delivered", 19.3, "#255b98", null],
];

export const options = {
  //title: "Density of Precious Metals, in g/cm^3",
 // width: 600,
  //height: 400,
  //backgroundColor: '#ECECEC',
  fontName: 'Roboto' , 
  fontSize: 13,
  bar: { groupWidth: "40%" },
  legend: { position: "none" },
  //colors: ['#2cb4d4','#1787b8','#255b98','#2f306d']
};

export default function DiffBarChart() {
  return (
    <Chart
      chartType="BarChart"
      width="100%"
      height="250px"
      data={data}
      options={options}
    />
  );
}
